export const ENVIRONMENT = import.meta.env.MODE;
export const FP_APP_URL = import.meta.env.VITE_FP_APP_BASE_URL;
export const CORP_APP_URL = import.meta.env.VITE_CORP_APP_BASE_URL;
export const CORP_UNBOUNCE_URL = import.meta.env.VITE_CORP_UNBOUNCE_URL;
export const LOOKBOOK_URL = import.meta.env.VITE_LOOKBOOK_URL;
export const SHOP_RETAIL_URL = import.meta.env.VITE_SHOP_RETAIL_URL;
export const V3_APP_BASE_URL = import.meta.env.VITE_V3_APP_BASE_URL;
export const API_SERVER_URL = import.meta.env.VITE_API_SERVER_URL;
export const PRODUCT_GALLERY_API_CONTEXT = 'HQ';

export const GROUP_ORDER_URL = `${FP_APP_URL}group-order`;
export const GROUP_ORDERS_STORE_BASE_URL = import.meta.env.VITE_GROUP_ORDERS_STORE_BASE_URL;
export const FP_DESIGN_URL = `${FP_APP_URL}designs`;
export const FP_PRODUCT_URL = `${FP_APP_URL}products`;
export const CORP_PRODUCT_URL = `${CORP_APP_URL}products`;
export const SIGN_UP_URL = `${FP_APP_URL}signup`;

export const ALGOLIA_URL = import.meta.env.VITE_ALGOLIA_BASE_URL;
export const ALGOLIA_KEY = import.meta.env.VITE_ALGOLIA_API_KEY;
export const ALGOLIA_ID = import.meta.env.VITE_ALGOLIA_APP_ID;
export const ALGOLIA_IDX = import.meta.env.VITE_ALGOLIA_INDEX;

export const ENCRYPTION_SECRET_KEY = import.meta.env.VITE_ENCRYPTION_SECRET_KEY;

export const CLOUD_FRONT_URL = import.meta.env.VITE_CLOUD_FRONT_URL;

export const CF_BASE_URL = `${CLOUD_FRONT_URL}`;

export const ALPHA_FRONT_IMAGE_URL = 'https://www.alphabroder.com/images/alp/prodDetail/';
export const ALPHA_BACK_IMAGE_URL = 'https://www.alphabroder.com/images/alp/backDetail/';

export const DESIGNS_BASE_URL = `${CLOUD_FRONT_URL}designs/`;

export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

export const DESIGN_TOOL = import.meta.env.VITE_DESIGN_TOOLS_ENDPOINT;

export const FULLSTORY_ORGID = import.meta.env.VITE_FULLSTORY_ORGID;

export const GTM_TAGID = import.meta.env.VITE_GTM_TAGID;

export const REFINER_TOKEN = import.meta.env.VITE_REFINER_TOKEN;

export const GOOGLE_PAY_MERCHANT_ID = import.meta.env.VITE_GOOGLE_PAY_MERCHANT_ID;

/** Google Identity Services client for Sheets / Contacts import (browser OAuth). */
export const GOOGLE_OAUTH_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID as
  | string
  | undefined;
export const GOOGLE_PICKER_API_KEY = import.meta.env.VITE_GOOGLE_PICKER_API_KEY as
  | string
  | undefined;
export const GOOGLE_CLOUD_PROJECT_NUMBER = import.meta.env.VITE_GOOGLE_CLOUD_PROJECT_NUMBER as
  | string
  | undefined;
/** Gate Contacts import until OAuth verification; Sheets uses the same client when set. */
export const GOOGLE_CONTACTS_IMPORT_ENABLED =
  String(import.meta.env.VITE_GOOGLE_CONTACTS_IMPORT_ENABLED ?? '').toLowerCase() === 'true' ||
  String(import.meta.env.VITE_GOOGLE_CONTACTS_IMPORT_ENABLED ?? '') === '1';
